import React, { Component } from "react";
import PropTypes from "prop-types";
import { withStyles, withTheme } from "@material-ui/core/styles";
import ReactGA from "react-ga";
import Button from "@material-ui/core/Button";
import AddIcon from "@material-ui/icons/Add";
import RemoveIcon from "@material-ui/icons/Remove";
import Slider from "rc-slider/lib/Slider";
import "rc-slider/assets/index.css";
import Paper from "@material-ui/core/Paper";
import { orange } from "@material-ui/core/colors";

const styles = theme => ({
  root: {
    textAlign: "center"
  },
  container: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center"
  },
  button: {
    margin: "0 15px"
  },
  routingError: {
    textAlign: "center"
  },
  paper: {
    ...theme.mixins.gutters(),
    paddingTop: theme.spacing.unit * 2,
    paddingBottom: theme.spacing.unit * 2,
    backgroundColor: orange[500]
    // color: "white"
  }
});

class Distance extends Component {
  minDistance = 10;
  maxDistance = 200;
  step = 5;

  state = {
    distance: 50
  };

  onSliderChange = value => {
    this.setState({
      distance: value
    });
  };

  addDistance = () => {
    ReactGA.event({
      category: "Route",
      action: "Removed 5 button"
    });
    this.setState(state => {
      return { distance: state.distance + 5 };
    });
  };

  removeDistance = () => {
    ReactGA.event({
      category: "Route",
      action: "Added 5 button"
    });
    this.setState(state => {
      return { distance: state.distance - 5 };
    });
  };

  returnDistance = () => {
    ReactGA.event({
      category: "Route",
      action: "Chose distance",
      value: this.state.distance
    });
    this.props.callback("distance", this.state.distance);
  };

  render() {
    const { classes, theme } = this.props;
    const { distance } = this.state;
    const addDisabled = distance === this.maxDistance;
    const removeDisabled = distance === this.minDistance;

    return (
      <div className={classes.root}>
        <Paper className={classes.paper} elevation={1}>
          <div className={classes.routingError}>
            We zijn nog druk bezig de automatische routering te optimaliseren.
            Hierdoor kan het zijn dat deze niet in alle gevallen volledig
            accuraat is. Indien je problemen ondervindt, geef ons zeker{" "}
            <a
              href="https://vrtenquete.typeform.com/to/iRJFWQ"
              target="_blank"
              rel="noopener noreferrer"
            >
              feedback
            </a>.
          </div>
        </Paper>
        <h1>Hoe ver wil je gaan?</h1>
        <h2>{distance} km</h2>
        <div className={classes.container}>
          <div className={classes.button}>
            <Button
              variant="fab"
              color="primary"
              aria-label="remove"
              onClick={this.removeDistance}
              disabled={removeDisabled}
            >
              <RemoveIcon />
            </Button>
          </div>
          <Slider
            value={this.state.distance}
            onChange={this.onSliderChange}
            min={this.minDistance}
            max={this.maxDistance}
            step={this.step}
            railStyle={{
              backgroundColor: theme.palette.grey,
              height: 10
            }}
            trackStyle={{
              backgroundColor: theme.palette.primary.light,
              height: 10
            }}
            handleStyle={{
              borderColor: theme.palette.primary.light,
              height: 28,
              width: 28,
              marginLeft: -14,
              marginTop: -9
            }}
          />
          <div className={classes.button}>
            <Button
              variant="fab"
              color="primary"
              aria-label="add"
              onClick={this.addDistance}
              disabled={addDisabled}
            >
              <AddIcon />
            </Button>
          </div>
        </div>
        <Button
          variant="raised"
          className={classes.button}
          onClick={this.returnDistance}
        >
          Volgende
        </Button>
      </div>
    );
  }
}

Distance.propTypes = {
  classes: PropTypes.object.isRequired,
  theme: PropTypes.object.isRequired,
  callback: PropTypes.func.isRequired
};

export default withTheme()(withStyles(styles)(Distance));



// WEBPACK FOOTER //
// ./src/NewRoute/components/Distance.js